import type Store from "@ember-data/store";
import Route from "@ember/routing/route";
import type RouterService from "@ember/routing/router-service";
import { service } from "@ember/service";
import type SessionService from "ember-simple-auth/services/session";

export default class IndexRoute extends Route {
  @service declare session: SessionService;
  @service declare router: RouterService;

  @service declare store: Store;

  beforeModel(transition) {
    const transitionName = transition?.to?.name;

    // Special case for these 2 login routes because they should be accessible even when we are authenticated
    // so we let the transition continue instead of redirecting to the "index" route that handles the already authenticated use cases
    if (transitionName == "login.medic-password-forgotten") return;
    if (transitionName == "login.patient-link") return;

    // "index" is the route responsible to 🔀 redirect users, medics or patients, to their correct pages
    if (this.session.isAuthenticated) this.router.transitionTo("index");
  }
}
